import type { RouteLocationNormalized } from 'vue-router';

import authorization from '@rygen/rygen-ui/authorization';
import environmentPropertiesStore from '@rygen/rygen-ui/env/EnvironmentPropertiesStore';
import { Module } from '@rygen/rygen-ui/model';

import { useCurrentUserStore } from '@/stores/CurrentUser';

export default async (
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
) => {
  const { domainContextIsInitialized, waitForDomainContextInitialization } =
    useCurrentUserStore();

  if (to?.meta?.requiredAuthorization == null) {
    return;
  }

  if (!domainContextIsInitialized.value) {
    await waitForDomainContextInitialization();
  }

  const hasAnyRequiredPermission = (
    to?.meta?.requiredAuthorization as string[][]
  ).some((permission) => {
    return authorization.hasAuthority(permission[0], permission[1]);
  });

  if (hasAnyRequiredPermission) {
    return;
  }

  if (!authorization.hasAccessToModule(Module.TMS)) {
    const url = getFirstModuleRedirectURL();
    if (url) {
      window.location.replace(url);
      return;
    }
  }

  return { name: '401' };
};

const getFirstModuleRedirectURL = () => {
  if (authorization.hasAccessToModule(Module.RATING)) {
    return environmentPropertiesStore.getValue('LIGHTNING_URL');
  } else if (authorization.hasAccessToModule(Module.BILLING)) {
    return environmentPropertiesStore.getValue('BILLING_URL');
  } else if (authorization.hasAccessToModule(Module.ANALYTICS)) {
    return environmentPropertiesStore.getValue('ANALYTICS_URL');
  } else if (authorization.hasAccessToModule(Module.FICON)) {
    return environmentPropertiesStore.getValue('FICON_URL');
  } else {
    return undefined;
  }
};
